import { UserRepository } from '../../domain/repository';
import { UserRepositoryImpl } from '../repository';

export const userProviders = [
  {
    provide: UserRepository,
    useExisting: UserRepositoryImpl,
  },
];


